module.exports = [
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-tud starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tud starter kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til kulsyretilsætning. Høj L-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-tud starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tud starter kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj L-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-tud starter kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj U-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-tud starter kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo startsæt: etgrebs-køkkenbatteri til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj U-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono startsæt",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono startsæt: søjlearmatur til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, rustfrit stål-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono startsæt",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono startsæt: søjlearmatur til filtreret, afkølet og kulsyretilsat vand. Indeholder køleenhed, filter og CO2-flaske til tilsætning af kulsyre. Høj C-tud, krombelægning.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Blandingsventil",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "GROHE RED Mono køkkenarmatur (L-tud) med filtersæt og kedel i størrelse M til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (L-tud) med filtersæt og kedel i størrelse M til øjeblikkeligt kogende vand. Mat, rustfrit stållook. Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (L-tud) med filtersæt og kedel i størrelse M til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (L-tud) med filtersæt og kedel i størrelse L til øjeblikkeligt kogende vand. Finish i mat, rustfrit stållook. Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (L-tud) med filtersæt og kedel i størrelse L til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE RED Mono køkkenarmatur (C-tud) med filtersæt og kedel i størrelse M til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (C-tud) med filtersæt og kedel i størrelse M til øjeblikkeligt kogende vand. Mat, rustfrit stållook. Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (C-tud) med filtersæt og kedel i størrelse M til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Armatur og kedel i strørrelse L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE RED Mono køkkenarmatur (C-tud) med filtersæt og kedel i størrelse L til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (C-tud) med filtersæt og kedel i størrelse L til øjeblikkeligt kogende vand. Mat, rustfrit st��llook. Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Armatur og kedel i størrelse L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Duo køkkenarmatur (C-tud) med filtersæt og kedel i størrelse L til øjeblikkeligt kogende vand. Krombelægning Energieffektivitet i klasse A og sikkerhedsfunktioner",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.dk/da_dk/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.dk/da_dk/hvor-kan-du-se-og-fole/find-en-grohe-partner.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_da_dk.json
// module id = 873
// module chunks = 0